import { render, staticRenderFns } from "./Contratar2.vue?vue&type=template&id=8ae70f62&scoped=true&"
import script from "./Contratar2.vue?vue&type=script&lang=js&"
export * from "./Contratar2.vue?vue&type=script&lang=js&"
import style0 from "./Contratar2.vue?vue&type=style&index=0&id=8ae70f62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae70f62",
  null
  
)

export default component.exports